import React from 'react';
import Logo from '../../Helper/Logo/logo';
import { history } from '../../store';
import {routeName} from '../../../src/Service/env';
import './errorPage.css';

const onLogoClick = () => {
    localStorage.clear();
    history.push(`/${routeName}`);
};

const ErrorComponent = () =>{
    return(
        <div className='error-container no-data'>
          <span onClick={onLogoClick}><Logo /></span>
            <h2 className='error-text'>The url is invalid. Click on the logo to get redirected to our homepage.</h2>
        </div>
    )
};
export default ErrorComponent;